import styled, { css } from 'styled-components'

interface IBox {
  color: string
  isAltered: boolean
}

const alteredCardBorder = css`
  border: 2px solid ${props => props.theme.colors.colorcd1f1f};
`

export const Card = styled.div<IBox>`
  position: relative;
  min-width: 233px;
  width: 100%;
  height: 69px;

  display: flex;
  align-items: center;
  gap: 8px;

  padding: 0 17px 0 8px;

  border-radius: 4px;
  ${({ isAltered }) => (isAltered ? alteredCardBorder : null)}
  border-left: 4px solid ${props => props.color};
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  transition: 0.2s;

  cursor: pointer;

  .arrow {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);

    svg {
      fill: transparent;
      width: 8px;
      height: 25px;
    }
  }

  :hover {
    background: ${props => props.theme.colors.colore5e9f1};
    .arrow svg {
      fill: ${props => props.theme.colors.color545e6c};
    }
  }
  :active {
    box-shadow: 3px 5px 13px -10px ${props => props.theme.colors.colorBlack1a};
  }
`

// ---------------------------------

interface IVariantIcon {
  color: string
}

export const VariantIcon = styled.div<IVariantIcon>`
  width: 25px;
  height: 25px;

  svg {
    color: ${props => props.color};
    fill: ${props => props.color};
    width: 24px;
    height: 24px;
  }
`

// ---------------------------------

export const InformationContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`

export const Title = styled.h4`
  font: normal normal bold 14px/17px Inter;
  margin-bottom: 11px;
  color: ${props => props.theme.colors.color6b7786};

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export const DateDescription = styled.span`
  font: normal normal normal 12px/15px Inter;
  color: ${props => props.theme.colors.color6b7786};
`

// ---------------------------------

export const AlertIndication = styled.div`
  position: absolute;
  right: 5px;
  top: 5px;

  svg {
    width: 15px;
    height: 15px;
    fill: ${props => props.theme.colors.colorcd1f1f};
  }
`

// ---------------------------------

export const BiRadsContainer = styled.div`
  position: absolute;
  left: 5px;
  top: 0;

  transform: translateY(-50%);
`
